export const actionsPrefix = 'STYLEBOARD_LIST'

export const TOGGLE_SELECT_FILTER = `${actionsPrefix}/TOGGLE_SELECT_FILTER`
export const TOGGLE_DESELECT_ALL_FILTERS = `${actionsPrefix}/TOGGLE_DESELECT_ALL_FILTERS`
export const APPLY_SELECTED_FILTERS = `${actionsPrefix}/APPLY_SELECTED_FILTERS`
export const TOGGLE_SORT_METHOD = `${actionsPrefix}/TOGGLE_SORT_METHOD`

export const ASCENDING = 'ascending'
export const DESCENDING = 'descending'
